import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw[] = [
  {
    path: '/console/account',
    redirect: '/console/account/profile',
    meta: { title: '账号', menu: false },
  },
  {
    path: '/console/account/profile',
    component: Layout,
    meta: { title: '账号信息', icon: 'i-lucide:user-round' },
    children: [{
      path: '',
      name: 'account',
      component: () => import('@/views/account/index.vue'),
      meta: { title: '账号信息', menu: false, breadcrumb: false },
    }],
  },
  {
    path: '/console/account/identity',
    component: Layout,
    meta: { title: '实名认证', icon: 'i-lucide:badge-check' },
    children: [{
      path: '',
      name: 'accountIdentity',
      component: () => import('@/views/account/identity.vue'),
      meta: { title: '实名认证', menu: false, breadcrumb: false },
    }],
  },
  {
    path: '/console/account/security',
    component: Layout,
    meta: { title: '安全设置', icon: 'i-lucide:shield-check' },
    children: [{
      path: '',
      name: 'accountSecurity',
      component: () => import('@/views/account/security.vue'),
      meta: { title: '安全设置', menu: false, breadcrumb: false },
    }],
  },
]

export default routes
